import '../IntegrationsTab.scss'
import React, { useMemo, useState } from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import { Button } from '../../../../components/Button/Button'
import { useDeleteUserIntegrationMutation, useGetMeQuery } from '../../../../store/user/user'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { MissingScopeAction } from '../../../../components/ScopedBlock/models'
import { ScopedBlock } from '../../../../components/ScopedBlock/ScopedBlock'
import { RedtailSettingsModal } from './RedtailSettingsModal'
import { IntegrationServiceId } from '../../../../common/integrations'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'
import { RedtailCredentialsModal } from '../../../Integration/Connectors/ModalIntegrationConnectors/Redtail/RedtailCredentialsModal'

export type RedtailIntegrationRowProps = { useIntegrationRedirectUri?: boolean }
export const RedtailIntegrationRow: React.FC<RedtailIntegrationRowProps> = ({ useIntegrationRedirectUri }) => {
  const accountId = useAppSelector(selectAccountId)
  const [showSettingsModal, setShowSettingsModal] = useState(false)
  const { data: userData } = useGetMeQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true })
  const [deleteUserIntegration, { isLoading: isDeletingIntegration }] = useDeleteUserIntegrationMutation()
  const hasRedtailIntegration = useMemo(() => {
    return !!(userData && userData.integrations && userData.integrations.some((i) => i.serviceId === IntegrationServiceId.REDTAIL))
  }, [userData])

  const uninstallRedtail = () => {
    const user = userData
    const integration = user!!.integrations!!.find((i) => i.serviceId === IntegrationServiceId.REDTAIL)
    deleteUserIntegration({
      accountId,
      payload: {
        userId: user!!.id,
        integrationId: integration!!.id,
      },
    })
  }

  const handleShowSettingsModal = async () => {
    setShowSettingsModal(true)
  }

  const handleHideSettings = () => {
    setShowSettingsModal(false)
  }

  const [showRedtailCredentialsModal, setShowRedtailCredentialsModal] = useState<boolean>(false)

  const handleRedtailCredentialsModal = () => {
    setShowRedtailCredentialsModal(false)
  }

  const handleConnect = () => {
    setShowRedtailCredentialsModal(true)
  }

  const handleOnSave = () => {
    setShowRedtailCredentialsModal(false)
  }

  return (
    <Container className='p-3 p-md-0 py-md-3 integration-container'>
      {showSettingsModal && <RedtailSettingsModal show={showSettingsModal} onHide={handleHideSettings} />}
      <RedtailCredentialsModal show={showRedtailCredentialsModal} onSave={handleOnSave} onCancel={handleRedtailCredentialsModal} />
      <Row className='d-flex justify-content-between'>
        <Col>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <div className='rounded py-1 px-1 zocks-bg-color-gray-100'>
              <IntegrationIcon serviceId={IntegrationServiceId.REDTAIL} width={48} height={48} />
            </div>
            <div>
              <h6>Redtail</h6>
              <div>Connect your Zocks account to Redtail.</div>
            </div>
          </Stack>
        </Col>
        <Col md='auto'>
          <Stack direction='horizontal' className='gap-3 align-items-start'>
            {hasRedtailIntegration && (
              <div className='d-flex gap-3'>
                <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'account:read', superScope: ['account:admin'] }}>
                  <Button variant='primaryGhost' onClick={handleShowSettingsModal}>
                    <i className='bi bi-gear' />
                  </Button>
                </ScopedBlock>
              </div>
            )}
            <div className='connect-button-container'>
              {hasRedtailIntegration ? (
                <div className='connect-button-container'>
                  <Button variant='primary' onClick={uninstallRedtail} loading={isDeletingIntegration}>
                    Disconnect
                  </Button>
                  <div className='pt-2 d-flex justify-content-end zocks-text-success'>
                    <i className='bi bi-check' />
                    Connected
                  </div>
                </div>
              ) : (
                <ScopedBlock
                  scope={{
                    scope: 'integration:connect',
                    superScope: ['integration:admin'],
                  }}
                  missingScopeAction={MissingScopeAction.DISABLE}
                >
                  <Button variant='primary' onClick={handleConnect}>
                    Connect
                  </Button>
                </ScopedBlock>
              )}
            </div>
          </Stack>
        </Col>
      </Row>
    </Container>
  )
}
